import { Input, Select, Space, Form, Col } from "antd";
import FormInputDivider from "./FormInputDivider";
import { StyledForm } from "../styles";

function PortalInputSufixos({input, divider, colSpan, ...props}){

    const MyOnChange = (newValue) =>{
        if(props.portalOnInputSufixosValueChange != null && typeof props.portalOnInputSufixosValueChange == "function"){
            props.portalOnInputSufixosValueChange(input.name,newValue)
        }
    }

    return(
        <FormInputDivider key={input.name} {...divider}>
            <Col span={colSpan ? colSpan : (props.inputColSpan? props.inputColSpan : 24)} key={input.name}>
                <Col span={input?.colSpan ? input.colSpan : 24} style={{padding:"0px"}}>
                        <Space.Compact  block={true}>
                                <StyledForm.Item {...input} extra={props.helpMessage} hidden={input.hidden} style={{width:'100%'}} onBlur={MyOnChange}>
                                    <Input disabled={input?.disabled} addonBefore={input?.addonBefore} />
                                </StyledForm.Item>
                                <StyledForm.Item name={input.name + 'Sufixo'} style={{width:'50%', marginTop:'30px'}}>
                                    <Select onChange={MyOnChange} disabled={input?.disabled}>
                                        {props.selectSufixoOptions}
                                    </Select>
                                </StyledForm.Item>
                        </Space.Compact>
                </Col>
            </Col>
        </FormInputDivider>
        
    )
}

export default PortalInputSufixos;
